<template>
  <div class="help-center">
    <Resource
      v-if="configData?.cover_url"
      class="w-full h-[266px] absolute left-0 top-0 z-0 object-cover"
      :src="configData?.cover_url"
      :transform-resource="transformImage"
    />
    <div class="z-10 relative">
      <div class="banner">
        <div class="text-center pt-[70px]">
          <h1 class="text-[24px] font-bold text-[var(--help-text-color)]">
            {{ configData?.title }}
          </h1>
          <div class="mt-[36px]">
            <Search
              ref="searchRef"
              v-model="keyword"
              type="normal"
              size="large"
              class="w-[690px] mx-auto"
              :placeholder="
                $t('qing-shu-ru-wen-ti-guan-jian-ci-ru-qi-ye-ban-quan-yi')
              "
              :area="SEARCH_RECORD_UNIQUE.HELP_CENTER"
              @search="handleOnSearch"
            >
            </Search>
          </div>
          <HotKeys
            class="w-[460px]"
            :area="SEARCH_RECORD_UNIQUE.HELP_CENTER"
            @select="selectTag"
          />
        </div>
      </div>
      <div class="w-[1200px] mx-auto mt-[90px] pb-[80px]">
        <div v-if="!isSearch" class="help-category-cards">
          <CardItem v-for="item in helpCategory" :key="item.id" :item="item" />
        </div>
        <div v-else class="result">
          <a-spin
            v-if="loadingResult"
            :spinning="loadingResult"
            class="block mx-auto"
          >
          </a-spin>
          <div v-else>
            <div v-if="resultData?.length">
              <div class="text-font-50">
                {{ $t('gong-paginationtotal-tiao-shu-ju', [pagination.total]) }}
              </div>
              <ResultItem
                v-for="item in resultData"
                :key="item.id"
                :keyword="splitWord"
                :item="item"
              />
              <div class="text-center mt-[56px]">
                <a-pagination
                  v-model:current="pagination.current"
                  :total="pagination.total"
                  :page-size="pagination.pageSize"
                  @change="onChange"
                />
              </div>
            </div>
            <Empty
              v-if="!pagination.total"
              :list="emptyList?.data"
              @select="selectTag"
              @refresh="emptyRefresh"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="!isSearch && isChinese()" class="help-center-footer">
      <Footer />
    </div> -->
  </div>
</template>

<script setup lang="ts" name="HelpCenter">
// 页面主体相关组件引入
import ResultItem from './components/main/resultItem.vue'
import CardItem from './components/main/mainItem.vue'

// 搜索相关组件引入
import Footer from './components/footer.vue'
import { useWatchPageSeoData } from '~/hooks/useSeo'
import Empty from '@/features/searchInput/empty.vue'
import Search from '@/features/searchInput/index.vue'
import HotKeys from '@/features/searchInput/hotKeys.vue'

// 底部相关组件引入

import {
  getPromotionCenterPageCard,
  getHelpCategory,
  getSearchCategoryResult,
  getSegmentWord,
  SEARCH_TYPE,
} from '~/api/index'
import { CONFIG_TYPE, SEARCH_HOT_WORD, SEARCH_RECORD_UNIQUE } from '~/constants'
import { PAGE_CARD_TYPE } from '~/api/interface/publicize'
import { getSiteHotWord } from '~/api/module/search'

// 先声明响应式变量
const keyword = ref('')
const searchRef = ref()
const isSearch = ref(false)
const splitWord = ref()
const loadingResult = ref(true)
const resultData = ref()
const pagination = ref<{
  page: number
  pageSize: number
  total: number
  current: number
}>({
  page: 1,
  pageSize: 10,
  total: 1,
  current: 1,
})

// const seoData = useSeoData()

// const config = ref()
// const route = useRoute()

const { data: emptyList, refresh: emptyRefresh } = useAsyncData(() =>
  getSiteHotWord(SEARCH_HOT_WORD.HELP, 6)
)

const resetPaginationAndResultData = () => {
  pagination.value.current = 1
  resultData.value = []
}

const selectTag = (val: string) => {
  if (val === keyword.value) {
    return
  }
  keyword.value = val
  resetPaginationAndResultData()

  searchRef.value?.search(val)
}

const onChange = (page: number, pageSize: number) => {
  pagination.value.current = page
  fetchResult()
}

const fetchResult = async (val?: string) => {
  try {
    loadingResult.value = true
    const res = await getSearchCategoryResult({
      keyword: val || keyword.value,
      page: pagination.value.current,
      page_size: pagination.value.pageSize,
    })
    resultData.value = res.data
    pagination.value.total = res.count
    loadingResult.value = false
  } catch (error) {
    console.error('获取搜索结果出现错误:', error)
    loadingResult.value = false
  }
}

const handleOnSearch = async (val: string) => {
  isSearch.value = true
  keyword.value = val

  await fetchResult(val)
  const res = await getSegmentWord(val)
  splitWord.value = res.data
}

//  watch
watch(
  () => keyword.value,
  () => {
    if (!keyword.value) {
      isSearch.value = false
    }
  }
)

const { data, status } = useAsyncData(() =>
  getHelpCategory({ model_type: SEARCH_TYPE.HELP_CENTER })
)

const { data: pageInfo } = useAsyncData(() =>
  getPromotionCenterPageCard({
    type: PAGE_CARD_TYPE.HEL_CENTER,
  })
)
const helpCategory = computed(() => data.value?.data)

const configData = computed(
  () =>
    pageInfo.value?.data?.find((item) => item.type === CONFIG_TYPE.HELP_CENTER)
)

useWatchPageSeoData(configData)
</script>

<style lang="scss" scoped>
.help-center {
  @apply relative;
  .help-category-cards {
    @apply grid  mx-auto w-[836px];
    grid-template-columns: repeat(3, minmax(24px, 1fr));
    row-gap: 24px;
    column-gap: 16px;
    justify-items: center;
    align-items: center;
  }
  // .help-center-footer {
  //   @apply pt-[98px] pb-[200px];
  //   background: var(--help-footer-bg);
  // }
}
</style>
